<template>
  <detail-layout-full-width>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="mandatory">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('clients.api_keys.secret') }}</label>
            <el-form-item prop="Secreto" ref="Secreto">
              <el-input
                clearable
                class="w-full"
                v-model="form.Secreto"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'

import { getClient } from '@/services/clients/getClient'
import { setConfigInmaticCliente } from '@/services/clients/setConfigInmaticCliente'
import { getInformacionInmaticCliente } from '@/services/clients/getInformacionInmaticCliente'

import { i18n } from '@/i18n'

export default {
  components: {
    DetailLayoutFullWidth
  },
  data () {
    return {
      header: {
        title: i18n.t('configInmatic.header'),
        icon: 'config',
        breadcrumb: {},
        url: 'configurations/clients/details'
      },
      form: {
        Secreto: '',
      },
      rules: {
        Secreto: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: ['change', 'blur'],
          },
        ],
      },
    }
  },
  async mounted () {
    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({ path: 'clients', name: i18n.t('clients.header') })
    
      const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
      if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
        breadcrumbs.push({ path: '', name: cabeceraStored })
      } else {
        const cliente = await this.getClientData()
        breadcrumbs.push({ path: '', name: cliente?.Nombre ?? '' })
        this.$store.commit('app/setheaderBreadCrumb', cliente?.Nombre ?? '')
      }
    }
    this.header.breadcrumb = breadcrumbs
    await this.getInmaticData(this.isFromClient ? this.clientID : null)
  },
  computed: {
    clientID: function () {
      return this.$route.params.id ?? -1
    },
    isFromClient: function () {
      return this.clientID !== -1
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  methods: {
    getInmaticData: async function (idCliente) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await getInformacionInmaticCliente({ idCliente })
        if (!response.blnError) {
          this.setConfig(response.response)
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getClientData: async function () {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: this.clientID
        }
        const response = await getClient(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
        client = response.Cliente
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    setConfig: function (data) {
      this.form.Secreto = data.ApiKey ?? ''
    },
    submitForm: async function (formName) {
      this.$store.commit('setIsLoading', true)
      setTimeout(() => {
        try {
          this.$refs[formName].validate(async valid => {
            if (valid) {
              const params = {
                ApiKey: this.form.Secreto,
                idCliente: null
              }
              if (this.isFromClient) {
                params.idCliente = parseInt(this.clientID)
              }
              const response = await setConfigInmaticCliente(params)
              if (response && response.blnError === false) {
                this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              } else {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              }
            } else {
              this.doFeedback(i18n.t('feedback.error.process_data_error'))
            }
          })
        } catch (error) {
          this.doFeedback(error)
        } finally {
          this.$store.commit('setIsLoading', false)
        }
      }, 100)
    },
    goBack: function () {
      this.$router.push({ name: 'clients' })
    }
  }
}
</script>

<style>

</style>
